import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import React from "react";
function EmailWidget(props) {
  var BaseInput = props.registry.widgets.BaseInput;
  return React.createElement(BaseInput, _extends({
    type: "email"
  }, props));
}
if (process.env.NODE_ENV !== "production") {}
export default EmailWidget;